import ReactOnRails from 'react-on-rails';
import { ToastController } from '@platform-ui/design-system';
// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({
  ToastController
});
